import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faCircleQuestion,
  faClockRotateLeft,
  faEnvelope,
  faFileInvoice,
  faGlobe,
  faHeadset,
  faLink,
  faRepeat,
  faRotateLeft,
  faStore,
} from '@fortawesome/free-solid-svg-icons';
import type { ITransaction } from './transaction';
import type { IFormattedTransaction } from './transaction-formatted';
import { TransactionType } from './transaction-type.enum';

// Virtual terminal / MOTO sales carry the order channel in the
// TransactDirect transaction type rather than the Portal one.
function motoOrderType(
  transaction: ITransaction,
): 'mail' | 'telephone' | undefined {
  if (
    transaction.transactionType !== TransactionType.VirtualTerminal &&
    (transaction.channel as string) !== 'moto'
  )
    return undefined;
  switch (transaction.transactTransactionType?.toUpperCase()) {
    case 'SALE_CNP_MO':
      return 'mail';
    case 'SALE_CNP_TO':
      return 'telephone';
    default:
      return undefined;
  }
}

export function transactionIcon(transaction: ITransaction): IconProp {
  switch (transaction.transactionType) {
    case TransactionType.VirtualTerminal:
      // Telephone orders keep the well-known headset icon; the tooltip
      // still distinguishes them.
      return motoOrderType(transaction) === 'mail' ? faEnvelope : faHeadset;
    case TransactionType.PEBL:
      return faLink;
    case TransactionType.ECOMMERCE:
      return faGlobe;
    case TransactionType.Refund:
      return faRotateLeft;
  }

  if (transaction.isReversal) return faClockRotateLeft;

  // the Portal BFF returns channels outside TransactionChannel (e.g. 'billing')
  switch (transaction.channel as string) {
    case 'recurring':
      return faRepeat;
    case 'billing':
      return faFileInvoice;
    case 'ecommerce':
      return faGlobe;
    case 'moto':
      // Telephone orders keep the well-known headset icon; the tooltip
      // still distinguishes them.
      return motoOrderType(transaction) === 'mail' ? faEnvelope : faHeadset;
    case 'cardholder_present':
      return faStore;
    default:
      return faCircleQuestion;
  }
}

export function transactionIconTooltip(
  transaction: IFormattedTransaction,
): string {
  switch (motoOrderType(transaction)) {
    case 'mail':
      return 'Mail Order';
    case 'telephone':
      return 'Telephone Order';
  }
  return transaction.isReversal ||
    transaction.transactionType === TransactionType.Refund
    ? transaction.formattedType
    : transaction.formattedChannel;
}
